import { AttachmentFileType, CloudFile, LocalComputerFile } from 'owa-attachment-file-types';
import { ShareAttachmentProperties, lazyUploadLocalFile } from 'owa-attachment-well-data';
import { onUploadDone } from '../actions/internalActions';

export async function uploadLocalFileToOneDrive(
    file: LocalComputerFile,
    upsellProperties: ShareAttachmentProperties,
    linkId: string
): Promise<CloudFile> {
    const uploader = await lazyUploadLocalFile.import();
    const [{ uploadPromise }, oneDriveProvider] = uploader(
        file.name,
        file.fileObject,
        upsellProperties.folderInfo,
        null /* ProgressHandler */
    );
    const {
        model: { Type: providerType },
    } = oneDriveProvider;

    const { errorResponse: uploadErrorResponse, result: uploadResult } = await uploadPromise;

    if (uploadErrorResponse) {
        const errorResponseBody = await uploadErrorResponse.text();
        const errorObj = {
            responseStatus: uploadErrorResponse.status,
            responseBody: errorResponseBody,
        };
        throw JSON.stringify(errorObj);
    }

    if (uploadResult) {
        const cloudFile: CloudFile = {
            fileType: AttachmentFileType.Cloud,
            name: file.name,
            size: file.size,
            providerId: null,
            providerType: providerType,
            providerEndpointUrl: null,
            fileId: uploadResult.id,
            location: uploadResult.webUrl,
            isFolder: false,
            thumbnailUrl: null,
            previewUrl: null,
            fileParentId: uploadResult.parentReference?.id,
            type: file.type,
        };
        onUploadDone(linkId, cloudFile);
        return cloudFile;
    }

    return null;
}
